export default "__VITE_ASSET__MlUZ5Z4T__"